export function loadMercadoPago(): Promise<MercadoPagoConstructor> {
  return new Promise((resolve, reject) => {
    if (window.MercadoPago) {
      resolve(window.MercadoPago);
      return;
    }

    const script = document.createElement("script");
    script.src = "https://sdk.mercadopago.com/js/v2";
    script.onload = () => {
      if (window.MercadoPago) {
        resolve(window.MercadoPago);
        return;
      }
      reject(new Error("No se pudo cargar MercadoPago"));
    };
    script.onerror = () => reject(new Error("No se pudo cargar MercadoPago"));
    document.body.appendChild(script);
  });
}

export function loadSecurityMercadoPago(): Promise<string> {
  return new Promise((resolve, reject) => {
    if (window.MP_DEVICE_SESSION_ID) {
      resolve(window.MP_DEVICE_SESSION_ID);
      return;
    }

    if (document.getElementById("mp-security-script")) {
      waitForDeviceSession(resolve, reject);
      return;
    }

    const script = document.createElement("script");
    script.id = "mp-security-script";
    script.src = "https://www.mercadopago.com/v2/security.js";
    script.setAttribute("view", "checkout");

    script.onload = () => {
      waitForDeviceSession(resolve, reject);
    };

    script.onerror = () => reject("Error cargando MercadoPago security.js");

    document.body.appendChild(script);
  });
}

export function waitForDeviceSession(
  resolve: (value: string) => void,
  reject: (reason: unknown) => void,
) {
  const start = Date.now();

  const interval = setInterval(() => {
    if (window.MP_DEVICE_SESSION_ID) {
      clearInterval(interval);
      resolve(window.MP_DEVICE_SESSION_ID);
    }

    if (Date.now() - start > 5000) {
      clearInterval(interval);
      reject(new Error("Timeout esperando MP_DEVICE_SESSION_ID"));
    }
  }, 100);
}
